import { useCallback, useEffect, useRef, useState } from "react";

export const useMediaHandler = ({ src, onError }) => {
  const mediaRef = useRef(null);
  const hasErrored = useRef(false);

  const [isLoading, setIsLoading] = useState(true);

  // ✅ When media starts loading again
  useEffect(() => {
    if (mediaRef.current?.load && src) {
      mediaRef.current.load();
    }
  }, [src]);

  // ✅ Success handlers
  const handleLoaded = useCallback(() => {
    setIsLoading(false);
  }, []);

  // ✅ Error handler
  const handleError = useCallback(async () => {
    if (hasErrored.current) {
      setIsLoading(false);
      return;
    } else {
      hasErrored.current = true;

      await onError?.();
    }
  }, [onError]);

  return {
    mediaRef,
    isLoading,
    handleError,
    handleLoaded,
  };
};
